import {ReactNode} from 'react';
import {Text} from '../../../atoms/Text/Text';

export function ContentGuide({children}: {children: ReactNode}) {
  return (
    <div className="w-full px-18pxr pb-16pxr">
      <Text className="font-medium2-bold whitespace-pre-wrap break-words text-theme-solid-100">
        {children}
      </Text>
    </div>
  );
}
